import DualColumnCtaCard from './DualColumnCtaCard'

export default DualColumnCtaCard
